const FaqModalContent = [
  {
    headerText: 'PAYMENTS & SHIPMENTS',
    altText: 'Credit cards',
    icon: '/icons/psp-faqs/payment-icon.svg',
    questions: [
      {
        question: `Why can’t I decide when to receive my shipments?`,
        answer: `It’s science and sustainability! We assess your lawn’s growth potential, climate, and predicted grass type, and factor in local restrictions and timing in the season to customize your plan. The products your lawn is craving will arrive before your application dates, in fewer shipments to reduce carbon emissions.`,
      },
      {
        question: `What does ‘pay today’ vs ‘total’ pricing mean?`,
        answer: `‘Pay today’ is what you’ll be charged today for your first lawn box. The ‘total’ price is the total cost of your custom lawn plan. All plans can be paid upfront or as each box ships. Cancel anytime.`,
      },
    ],
  },
  {
    headerText: 'SAFETY',
    altText: 'Safety badge',
    icon: '/icons/psp-faqs/safety-icon.svg',
    questions: [
      {
        question: `Is Sunday safe for children, pets, and the environment?`,
        answer: (
          <>
            Your family's safety is at the forefront of Sunday. You’ll have
            peace of mind with pesticide-free fertilizers and glyphosate-free
            weed control. Our ingredients are made to work <em>with</em> nature
            and won't persist in the environment. Once dry, your lawn is safe
            for kids and pets to play on.
          </>
        ),
      },
      {
        question: `Are these wildflowers eco-appropriate?`,
        answer: `Your wildflower seeds were selected by native plant experts to fit your region and grow easily. Did we mention they’re hardy, disease-resistant, and preferred by local pollinators? Beautiful.`,
      },
    ],
  },
  {
    headerText: 'EFFICACY & EFFORT',
    altText: 'Star in circle',
    icon: '/icons/psp-faqs/efficacy-icon.svg',
    questions: [
      {
        question: `What’s the time commitment?`,
        answer: `You’ll grow your best lawn yet with minimal effort. Most Sunday products can be applied in under 10 minutes, requiring just a few applications spring to fall. Once signed up you'll find easy instructions and application dates in your custom “My Plan” checklist. All you need is a hose or spreader; we provide the rest. `,
      },
      {
        question: `Does Sunday work for my grass?`,
        answer: (
          <>
            Our fertilizers and plans are formulated to nourish <em>any</em>{' '}
            grass type. Whether you have cool-season grasses like fescue,
            bluegrass, and ryegrass, or warm-season favorites such as St.
            Augustine, bermudagrass, and zoysiagrass—Sunday’s a match.
          </>
        ),
      },
      {
        question: `What if I need a different grass seed?`,
        answer: `If our seed pick doesn't feel right, simply opt for a plan without seed and add your preference to your cart separately. Unsure of coverage? Call, email, or text our Yard Advisors for personalized guidance. With free shipping, you can order more anytime!`,
      },
      {
        question: `I have lots of weeds, will Dandelion Doom work? `,
        answer: `Dandelion Doom is your go-to for tackling broadleaf weeds such as dandelions, dollarweed, and clover, as well as moss and lawn diseases. For tougher challenges, add Weed Warrior to your cart separately to eliminate unwelcome vegetation in your yard. Both are fast-acting and made without harsh chemicals. Once dry, your lawn is safe to play on.`,
      },
      {
        question: `What if I don’t have a hose, or can’t reach a hose across my lawn?`,
        answer: `We get it. Whether you're dealing with an automatic sprinkler system or managing a vast lawn, our granular fertilizers have you covered. They’re nutrient-rich, available for lawns over 3,000 square feet—and no hose is required. Just spread, set your sprinklers, and let your plan do the rest.`,
      },
      {
        question: `How is Sunday better or different than other lawn subscriptions?`,
        answer: `Sunday's not your average lawn care—we blend science and real-time data to innovate for your lawn season after season. You’ll receive climate-resilient products, custom  “My Plan” instructions and application plan, and dedicated support from our Expert Yard Advisors.`,
      },
      {
        question: `What if Sunday doesn’t work for my lawn?`,
        answer: `Your Sunday Guarantee: We’ve got what it takes to help you grow better. Expert Yard Advisors are available by phone, email, or text to provide you with personalized lawn guidance and support. Not satisfied? You can cancel online at any time.`,
      },
    ],
  },
  {
    headerText: 'SOIL TESTS',
    altText: 'Certificate with star',
    icon: '/icons/psp-faqs/soil-results-icon.svg',
    questions: [
      {
        question: 'Should I wait for my soil test results?',
        answer: `No need to wait—start your plan right away! Your first box contains nutrients tailored to your lawn preferences, climate, and growth plan along with the soil test you’ll send in. After we receive your soil sample, we’ll analyze it for deficiencies and fine-tune your plan if needed.`,
      },
    ],
  },
];

export default FaqModalContent;
